<template>
  <div class="vx-popup-share" v-if="opened" @click="close">
    <div v-if="isApp" class="apptips">
      <div>云校 App 后续迭代会补充分享功能，目前可使用 “校管家云校”公众号进行分享。</div>
      <div class="tip2">对给您带来的不便表示抱歉。</div>
    </div>
    <img v-else class="b1" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/share/004.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      // isApp: app.base.env == 'xgj',
      // 20211201APP已经支持分享
      isApp: false,
    };
  },
  methods: {
    show(opts) {
      this.opened = true;
      return new Promise(resolve => {
        this._resolve = resolve;
      });
    },
    close() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.vx-popup-share {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  overflow: auto;
  z-index: 99999;
  .b1 {
    display: block;
    width: 100%;
  }
  .apptips {
    padding: 50px 25px;
    color: rgba(var(--white-rgb), 0.8);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    .tip2 {
      padding-top: 20px;
    }
  }
}
</style>
